import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { V1User, type V1UserConstructor } from './V1User'

export const V1UserConstructorFactory =
  Factory.Sync.makeFactory<V1UserConstructor>({
    id: Factory.each(() => faker.random.number()),
    authId: Factory.each(() => faker.random.number()),
    email: Factory.each(() => faker.internet.email()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    position: Factory.each(() => faker.name.jobTitle()),
    phone: Factory.each(() => faker.phone.phoneNumber()),
    profileImage: Factory.each(() => faker.internet.url()),
    slackUserId: Factory.each(() => null),
  })

export const V1UserFactory = EntityFactory(V1User, V1UserConstructorFactory)
